import Button from '@talkdesk/cobalt-react-button'
import Box from '@talkdesk/cobalt-react-box'

/** @param {{ children?: any, submitLabel: any, disabledForm: any, onSubmit: any, isFormValid: any, isDanger?: boolean }} props */
const NoRecaptchaSecureForm = ({
  children,
  submitLabel,
  disabledForm,
  onSubmit,
  isFormValid,
  isDanger = false,
}) => {
  const isSubmitDisabled = disabledForm || !isFormValid

  const handleFormSubmit = (event) => {
    event.preventDefault()
    if (isSubmitDisabled) {
      return
    }
    onSubmit()
  }

  return (
    <Box paddingY='2' width='100%'>
      <form onSubmit={handleFormSubmit}>
        {children}
        <Box paddingY='2' width='100%'>
          <Button
            htmlType='submit'
            disabled={isSubmitDisabled}
            type={isDanger ? 'danger' : 'primary'}
            shape='full-width'
          >
            {submitLabel}
          </Button>
        </Box>
      </form>
    </Box>
  )
}

export default NoRecaptchaSecureForm
